import { Fragment } from 'react';
import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ResponsiveText = function ResponsiveText(_ref) {
  var text = _ref.text,
    className = _ref.className;
  if (typeof text === 'string') {
    if (className) {
      return /*#__PURE__*/_jsx("span", {
        className: className,
        children: text
      });
    }
    return /*#__PURE__*/_jsx(Fragment, {
      children: text
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: cn(className, {
        'sm:hidden': !!text.sm,
        'md:hidden': !text.sm && !!text.md,
        'lg:hidden': !(text.sm || text.md) && !!text.lg
      }),
      children: text.xs
    }), text.sm && /*#__PURE__*/_jsx("span", {
      className: cn(className, 'hidden sm:inline', {
        'md:hidden': !!text.md,
        'lg:hidden': !text.md && !!text.lg
      }),
      children: text.sm
    }), text.md && /*#__PURE__*/_jsx("span", {
      className: cn(className, 'hidden md:inline', {
        'lg:hidden': !!text.lg
      }),
      children: text.md
    }), text.lg && /*#__PURE__*/_jsx("span", {
      className: cn(className, 'hidden lg:inline'),
      children: text.lg
    })]
  });
};
export default ResponsiveText;